module.exports = __webpack_public_path__ + "img/welcomes-icon-2.c6287b4b.png";